module.exports = __webpack_public_path__ + "img/mobile/Background/background@2x.jpg?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Background/background@2x.jpg
// module id = 585
// module chunks = 0